import * as React from 'react';
import { Segment, Container, Header, Grid, Button, Image } from 'semantic-ui-react';
import { ExpandableProblemSolutionItem } from './ExpandableProblemSolutionItem';
import { Link } from 'react-router-dom';

export const SolutionSegment = (props: any) =>
  <Segment id="solution-segement" style={{ padding: '0em' }} vertical>
    <Container>

      <Header
        as="h1"
        textAlign='center'
        style={{ paddingTop: "2em" }}
      >
        The Solution: Lonch
        </Header>


      <Grid container stackable verticalAlign='middle'
        style={{ paddingTop: "2em", paddingBottom: "3em" }}>
        <Grid.Row>
          <Grid.Column width={8}>
            <p style={{ fontSize: '1.33em' }}>
              Lonch reduces the risk of bringing an unknown product to market. By moving compensation back to when a product makes money, contributors are empowered to bring a product to market fast and iterate. This also eliminates one of the biggest costs of starting a business: acquiring and paying domain experts.</p>
            <p style={{ fontSize: '1.33em' }}>
              Lonch is there for you every step of the way to bring a product to market, from bootstrapping, budgeting, execution, to marketing and shipping.</p>
          </Grid.Column>
          <Grid.Column floated='right' textAlign="center" width={6}>
            <Image
              size='large'
              src='/images/lonch-solution.png'
              style={{ display: "inline-block" }}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>

      <Grid columns='equal' stackable>

        <Grid.Row textAlign='center' style={{ paddingBottom: 0 }}>

          <ExpandableProblemSolutionItem
            icon='child'
            header="It starts with you"
            description={() => <p>You join and add your skills to the ecosystem. Without people like you, this service is nothing. Because of you, the possibilities are endless. </p>}
            more={() => <p>Lonch is made up of people like you. Passionate people with domain expertise willing to take on ownership and delayed satisfaction to be a part of something bigger.</p>}
          />

          <ExpandableProblemSolutionItem
            icon='idea'
            header="Pitch or join a product"
            description={() => <p>Find a product you're passionate about and join. Pitch a unique product to the community and recruit others. Or help out multiple products.</p>}
            more={() => <p>It is our beleif that passionate people with domain expertise, and tied directly into the royalty stream will make more informed decisions.</p>}
          />

          <ExpandableProblemSolutionItem
            icon='users'
            header="Open / Closed Product"
            description={() => <p>Lonch learned how to be more fluid from the Open Source community and provide vision and ownership from the traditional business model</p>}
            more={() => <p>Capitalize on contributors who perform similar work across multiple products. Enable them to come, make their contribution and go all while maintaining ownership.</p>}
          />

        </Grid.Row>

        <Grid.Row textAlign='center' style={{ paddingTop: 0 }}>

          <ExpandableProblemSolutionItem
            icon='pie graph'
            header="Slicing the Pie"
            description={() => <p>Compensation occurs on the backend. All effort is tracked and saved in the Blockchain. When a product begins to makes money, so do its contributors.</p>}
            more={() => <p>Lonch issues Royalty Tokens for work rendered, the percentage of these tokens owned by any individiual directly relates to the amount of royalties issued per pay period.</p>}
          />

          <ExpandableProblemSolutionItem
            icon='hourglass half'
            header="Invest in yourself"
            description={() => <p>Apply our expertise and available time to build an investment in a diversified portofolio of products. Gain the potential for much larger rewards.</p>}
            more={() => <p>You have worked hard, it's time that the hard work starts to work for you. We financial investments should take a backseat to sweat equity.</p>}
          />

          <ExpandableProblemSolutionItem
            icon='world'
            header="Freedom"
            description={() => <p>Become the master or your work life balance, in a way that has never been this easy before. Work as much as you want, on whatever you want, wherever you want.</p>}
            more={() => <p>Contribute to a multitude of products started by others, or launch your own. If you want to branch out to an entirely different market, there’s no better place. </p>}
          />

        </Grid.Row>



      </Grid>

      <Container
        textAlign="center"
        style={{ paddingBottom: '6em', paddingTop: "4em" }}
      >
        <Button as={Link} to="/sign-up" primary size="huge">
          Sign Up Now
          </Button>
      </Container>

    </Container>

  </Segment>


// WEBPACK FOOTER //
// ./src/home/SolutionSegment.tsx